import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {AddAPhoto} from "@mui/icons-material";
import {useEffect, useRef, useState} from "react";
import useRequestedDocumentRepository from "../../../../../../repository/emergency/useRequestedDocumentRepository";
import useDocumentRepository from "../../../../../../repository/document-storage/useDocumentRepository";
import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import RequestedDocument from "../../../../../../entity/emergency/RequestedDocument";
import useAlert from "../../../../../../use/useAlert";
import isNull from "../../../../../../mixin/isNull";
import Compressor from 'compressorjs';

export default function ({interventionId, qualityInspectionId}) {
    const alert = useAlert();
    const requestedDocumentRepository = useRequestedDocumentRepository();
    const documentRepository = useDocumentRepository();
    const qualityInspectionRepository = useQualityInspectionRepository();
    /** @type RequestedDocument[] */
    const requestedDocuments = requestedDocumentRepository.findAllByInterventionId(interventionId).select();
    const pictureInput = useRef();
    const [loading, setLoading] = useState(false);
    const interval = useRef();

    useEffect(() => {
        requestedDocumentRepository.findAllByInterventionId(interventionId).exec();

        return () => clearInterval(interval.current);
    }, []);

    const handleTakePictureClick = () => pictureInput.current.click();

    const handleUpload = e => {
        const file = e.target.files[0];

        if (isNull(file)) return;

        setLoading(true);

        if (file.type.startsWith("image")) {
            const options = {
                quality: 0.3,

                // Compression success callback: upload the compressed binary blob.
                success: result => submit(result),
                error: () => setLoading(false)
            };

            new Compressor(file, options);
        } else {
            // Non-image files are uploaded as-is (raw binary).
            submit(file);
        }
    }

    const submit = async file => {
        const target = requestedDocuments.find(rd => rd.getStatus() === RequestedDocument.STATUS_REQUESTED && rd.getName().includes("Attestation"));

        if (isNull(target)) {
            alert.error("Une erreur s'est produite");
            setLoading(false);
            return;
        }

        // First store the raw binary in service-document-storage and get back its id.
        const documentId = await documentRepository.uploadFile(file);

        if (isNull(documentId)) {
            alert.error("Échec de l'upload du document.");
            setLoading(false);
            return;
        }

        // Then link that document id to the requested document in service-emergency.
        const res = await requestedDocumentRepository.update(target.getId(), "document_id", {
            requested_document: {
                document_id: documentId
            }
        });

        if (!res) {
            setLoading(false);
            return;
        }

        await qualityInspectionRepository.update(qualityInspectionId, "skip_electronic_signature", null);

        interval.current = setInterval(() => {
            qualityInspectionRepository.findOneById(qualityInspectionId).exec(false);
        }, 5000);
    }

    if (isNull(requestedDocuments)) return null;

    return (
        <>
            <Typography display={"block"} color={"error"}>
                <Typography display={"inline"} fontWeight={"bold"}>
                    Étape 1.&nbsp;
                </Typography>
                Faites un devis papier, en recopiant à la lettre les éléments ci-dessus
            </Typography>
            <Typography variant="caption">
                "Tout manquement aux obligations d'information précontractuelle mentionnées aux 1° à 4°
                et 6° de l'article L. 111-1 et aux articles L. 111-2 et L. 111-3 est passible d'une
                amende administrative dont le montant ne peut excéder 3 000 euros pour une personne
                physique et 15 000 euros pour une personne morale. Cette amende est prononcée dans les
                conditions prévues au chapitre II du titre II du livre V."
            </Typography>

            <Typography display={"block"} color={"error"} mt={5}>
                <Typography display={"inline"} fontWeight={"bold"}>
                    Étape 2.&nbsp;
                </Typography>
                Faites signer le devis papier par le sociétaire
            </Typography>

            <Box mt={5}>
                <Button
                    startIcon={<AddAPhoto/>}
                    variant={"contained"}
                    fullWidth
                    onClick={handleTakePictureClick}
                    disabled={loading}
                    data-test="button-upload-quotation"
                >
                    Prenez votre devis en photo
                </Button>
                <input
                    ref={pictureInput}
                    style={{display: "none"}}
                    type={"file"}
                    accept="*/*"
                    onChange={handleUpload}
                    data-test="input-file"
                />
            </Box>
        </>
    )
}